import React, { useEffect, useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [language, setLanguage] = useState('th');

  // Function to get the language from localStorage
  const getLanguageFromLocalStorage = () => {
    const lang = localStorage.getItem('lang');
    if (lang) {
      setLanguage(lang);
    } else {
      localStorage.setItem('lang', 'th');
    }
  };

  useEffect(() => {
    getLanguageFromLocalStorage();
  }, []);

  const footerContent = {
    th: {
      menuTitle: 'เมนูอาหาร',
      menuItems: ['จานหลัก', 'ของหวาน', 'เครื่องดื่ม'],
      followTitle: 'ติดตามเรา',
      followItems: ['TikTok', 'Facebook', 'Instagram'],
      copyright: 'Copyright &copy; 2024 gow-chirp.co.th All Rights Reserved.'
    },
    en: {
      menuTitle: 'Menu',
      menuItems: ['Main Dishes', 'Desserts', 'Drinks'],
      followTitle: 'Follow Us',
      followItems: ['TikTok', 'Facebook', 'Instagram'],
      copyright: 'Copyright &copy; 2024 gow-chirp.co.th All Rights Reserved.'
    },
    cn: {
      menuTitle: '菜单',
      menuItems: ['主菜', '甜点', '饮料'],
      followTitle: '关注我们',
      followItems: ['TikTok', 'Facebook', 'Instagram'],
      copyright: 'Copyright &copy; 2024 gow-chirp.co.th All Rights Reserved.'
    }
  };

  const currentContent = footerContent[language];

  return (
    <footer className="footer pt-5 pb-4">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <h1 className="footer-logo">โกวเจี๊ยบ</h1>
            <p>Food is culture, And we need to listen to it.<br/> - ROBERT IRVINE</p>
          </div>
          <div className="col-6 col-md-3 mb-4 mb-md-0">
            <h3>{currentContent.menuTitle}</h3>
            <ul className="list-unstyled">
              {currentContent.menuItems.map((item, index) => (
                <li key={index}>
                  <a href={`/menu?type=${index + 1}`}>{item}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-6 col-md-3 mb-4 mb-md-0">
            <h3>{currentContent.followTitle}</h3>
            <ul className="list-unstyled">
              {currentContent.followItems.map((item, index) => (
                <li key={index}>
                  <a href="/">{item}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-12 col-md-3 mb-4 mb-md-0">
            {/* Optionally add any other content here */}
          </div>
        </div>
      </div>
      <div className="footer-bottom mt-4">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <hr />
              <p className="text-center copyright" dangerouslySetInnerHTML={{ __html: currentContent.copyright }} />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
